/* eslint-disable no-unused-vars */
import axios from "../../axios";

const state = {
  students: [],
  city: [],
  studentDetail: {},
  studentConversation: {},
  studyList: [],
  pagination: {
    current_page: 1,
    per_page: 60,
    total: 0,
  },
};

const actions = {
  /**
   * Get list students
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getLists({ commit }, query) {
    try {
      const response = await axios.get(
        `/user/students?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        commit("SET_LIST_STUDENTS", response.data);
      }
      return response;
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  async getReport({ commit }, query) {
    try {
      const response = await axios.get(
        `/user/students/report?${new URLSearchParams(query)}`
      );
      return response.data.data;
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  async getListStudy({ commit }, payload) {
    const response = await axios.get(`/user/student/study-infomation`, {
      params: payload,
    });
    if (response.status === 200) {
      commit("SET_LIST_STUDY_INFOMATION", response.data.data);
    }
    return response;
  },

  /**
   * Get list city
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListsCity({ commit }) {
    try {
      const response = await axios.get("/master/provinces");
      if (response.status === 200) {
        commit("SET_LIST_CITY", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Detail
   * @param commit
   * @param id
   * @returns {Promise<{}|*>}
   */
  async detail({ commit }, id) {
    const query = {
      "filter[role_id]": 3,
      include: [
        "student",
        "student.level",
        "student.entrancelevel",
        "student.sm",
        "student.ec",
      ],
      append: [
        "total_booking",
        "total_attended",
        "last_attendance",
        "avg_classes_in_week",
      ],
      "fields[student.sm]": "service_officer_id,fullname,avatar",
      "fields[student.ec]": "educational_consultant_id,fullname,avatar",
      "fields[student.level]": "id,title",
      "fields[student.entrancelevel]": "id,title",
    };
    try {
      const response = await axios.get(
        `/user/students/${id}?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        return commit("SET_STUDENT_DETAIL", response.data.data);
      }
      return {};
    } catch (e) {
      console.log("exception: ", e);
      return {};
    }
  },

  /**
   * Detail
   * @param commit
   * @param id
   * @returns {Promise<{}|*>}
   */
  async detailStudent({ commit }, id) {
    const query = {
      "filter[role_id]": 3,
      include: [
        "student",
        "student.level",
        "student.entrancelevel",
        "student.sm",
        "student.ec",
        "province",
        "latestCourse.course",
        "enrollmentBookSchedules",
        "enrollmentAttendedSchedules",
        "latestAttendEnrollmentSchedules",
      ],
      "fields[student.sm]": "id,name,avatar",
      "fields[student.ec]": "id,name,avatar",
      "fields[student.level]": "id,title",
      "fields[student.entrancelevel]": "id,title",
    };
    try {
      const response = await axios.get(
        `/user/students/${id}?${new URLSearchParams(query)}`
      );
      return response.data.data;
    } catch (e) {
      console.log("exception: ", e);
      return {};
    }
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post("/user/students", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  /**
   * Update
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`/user/students/${id}`, payload);
  },

  /**
   * Delete
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`/user/students/${id}`);
  },

  /**
   * delete multiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post("/user/students/delete-multiple", payload);
  },

  /**
   * reset password
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async resetPassword({ commit }, { id }) {
    return await axios.post(`/user/students/${id}/reset-password`);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },

  async import({ commit }, payload) {
    return await axios.post("/user/students/import", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  /**
   * Get conversation student
   * @param commit
   * @param id
   * @returns {Promise<{}|*>}
   */
  async detailConversation({ commit }, { email, uid }) {
    try {
      const response = await axios.get(
        `/student-conversation?email=${email}&uid=${uid}`
      );
      if (response.status === 200) {
        return commit("SET_STUDENT_CONVERSATION", response.data.data);
      }
      return {};
    } catch (e) {
      console.log("exception: ", e);
      return Promise.reject(e);
    }
  },

  async validateEmail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/user/students/validate-email', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response.data.message || error.response.data.error.message);
        });
    });
  },

  async validatePhone({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/user/students/validate-phone', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response.data.message || error.response.data.error.message);
        });
    });
  },
  async assignMultiple({ commit }, payload) {
    return await axios.post(
      "/user/students/assign-multiple",
      payload,
    );
  },
  async search({ commit }, params) {
    const response = await axios.get("/user/students", { params });
    return response.data;
  },
  async merge({ commit }, payload) {
    return await axios.post("/user/students/merge", payload);
  },
};

const mutations = {
  SET_LIST_STUDENTS(state, response) {
    state.students = response.data;
    state.pagination = response.meta;
  },
  SET_LIST_CITY(state, data) {
    state.city = data;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  SET_STUDENT_DETAIL(state, data) {
    state.studentDetail = data;
  },
  SET_STUDENT_CONVERSATION(state, data) {
    state.studentConversation = data;
  },
  SET_LIST_STUDY_INFOMATION(state, data) {
    state.studyList = data;
  },
};

const getters = {
  getListStudent(state) {
    return state.students;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
